/**
 * 全局配置文件
 *
 * Update by liubaorui on 22/11/15.
 *  添加 dictionaryId openDictionar isSeparator getPersistenceApi setPersistenceApi
 * 22/11/19.
 *  添加 captchaModeErrCount 验证码失效次数后开启  * captchaModeErrCount 值不为false时 即使关闭 captchaMode 验证码模式仍然生效
 */
export default {
  title: "宁国运中卫公铁物流园",
  logo: "S",
  key: 'saber',//配置主键,目前用于存储
  indexTitle: '宁国运中卫公铁物流园',
  // clientId: 'platform_enterprise', // 企业端id
  // clientSecret: 'platform_enterprise_secret', // 企业端密钥
  // clientId: 'platform_custom', // 客户端id
  // clientSecret: 'platform_custom_secret', // 客户端密钥
  // clientId: 'platform_carrier', // 承运商端id
  // clientSecret: 'platform_carrier_secret', //承运商端密钥
  // clientId: 'platform_driver', // 司机端id
  // clientSecret: 'platform_driver_secret', // 司机端密钥
  clientId: 'client_enterprise', // 框架默认id
  clientSecret: 'client_enterprise_secret', // 框架默认密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: "000000", // 管理组租户编号
  captchaMode: true, // 是否开启验证码模式
  captchaModeErrCount: 5, //验证码模式是否 在 x 个失效次数后开启。
  switchMode: false, // 是否开启部门切换模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //配置首页不可关闭
  isFirstPage: false,
  dictionaryName: '查看脱敏信息', //可以查看非脱敏信息的角色名称 取值于用户role_name
  openDictionar: true, //是否全局开启脱敏模式 关闭后即使符合传入规则也将忽略
  isSeparator: true, //是否全局千位分割符， 关闭后即使符合传入规则也将忽略
  getPersistenceApi: 'api/blade-userhabit/userhabit/getByUrl',  //获取操作列保存的数据接口
  setPersistenceApi: 'api/blade-userhabit/userhabit/save', //设置操作列需要保存的数据的接口
  fistPage: {
    label: "首页",
    value: "/wel/index",
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  //配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  },
  // 第三方系统授权地址
  authUrl: 'http://localhost/blade-auth/oauth/render',
  // 报表设计器地址(cloud端口为8108,boot端口为80)
  //reportUrl: 'http://localhost:8108/ureport',
  // 单点登录系统认证(blade-auth服务的地)
  ssoUrl: 'http://localhost:8100/oauth/authorize?client_id=saber&response_type=code&redirect_uri=',
  // 单点登录回调地址(Saber服务的地址)
  redirectUri: 'http://localhost:1888',
  // 润乾报表设计器地址
  reportUrl: 'http://' + window.location.hostname + ':8082/rqReport/reportJsp/showReport.jsp?',
 
  /**
   * 系统界面水印配置
   */
  //是否启用系统界面水印
  waterMarkEnable : false,
  //界面水印内容多少毫秒刷新一次
  waterMarkInterval : 1000,
}
